module.exports = __webpack_public_path__ + "img/chatSendButton.c6b97184.svg";